import {
  java,
  javascript,
  c,
  python,
  jobs,
  benjamin,
  anne,
  apj,
  archer,
  alchemist,
  sherlock,
  dark,
  stephen,
  unlock,
  brief,
  blackholes,
} from "./images/index";
import { Books } from "./interfaces";
export const books: Books = {
  Recommendations: [
    {
      name: "Eloquent JS",
      img_URL: javascript,
      auth: "Marijn Haverbeke",
      rating: "4.5/5",
      buy_link: "gdjjdgj",
      price: 2500,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Steve Jobs: The Exclusive Biography",
      img_URL: jobs,
      auth: "Walter Isaacson ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 150,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "A Brief History Of Time: From Big Bang To Black Holes",
      img_URL: brief,
      auth: "Stephen Hawking ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 180,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Complete Novels of Sherlock Holmes",
      img_URL: sherlock,
      auth: "Arthur Conan Doyle",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 140,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
  ],
  Programming: [
    {
      name: "Eloquent JS",
      img_URL: javascript,
      auth: "Marijn Haverbeke",
      rating: "4.5/5",
      buy_link: "gdjjdgj",
      price: 2500,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "C language",
      img_URL: c,
      auth: "Darrel L. Graham",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 230,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Java",
      img_URL: java,
      auth: "E Balagurusami",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 400,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Python",
      img_URL: python,
      auth: "Ike Beck",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 350,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
  ],
  Biography: [
    {
      name: "The Autobiography of Benjamin Franklin",
      img_URL: benjamin,
      auth: "Benjamin Franklin",
      rating: "4.5/5",
      buy_link: "gdjjdgj",
      price: 130,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Diary of a Young Girl",
      img_URL: anne,
      auth: "Anne Frank",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 120,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Wings of Fire: An Autobiography of Abdul Kalam",
      img_URL: apj,
      auth: " A. P. J. Abdul Kalam ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 150,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Steve Jobs: The Exclusive Biography",
      img_URL: jobs,
      auth: "Walter Isaacson ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 190,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
  ],
  Science: [
    {
      name: "Unlocking the Universe",
      img_URL: unlock,
      auth: "Stephen Hawking ",
      rating: "4.5/5",
      buy_link: "gdjjdgj",
      price: 160,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Theory of Everything: The Origin and Fate of the Universe",
      img_URL: stephen,
      auth: "Stephen Hawking ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 210,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "Black Holes: The Reith Lectures",
      img_URL: blackholes,
      auth: "Stephen Hawking ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 260,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "A Brief History Of Time: From Big Bang To Black Holes",
      img_URL: brief,
      auth: "Stephen Hawking ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 140,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
  ],
  Fiction: [
    {
      name: "Dark Matter: A Mind-Blowing Twisted Thriller",
      img_URL: dark,
      auth: "Stephen Hawking",
      rating: "4.5/5",
      buy_link: "gdjjdgj",
      price: 130,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Complete Novels of Sherlock Holmes",
      img_URL: sherlock,
      auth: "Arthur Conan Doyle",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 140,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Alchemist",
      img_URL: alchemist,
      auth: "Paulo Coelho ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 170,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
    {
      name: "The Archer",
      img_URL: archer,
      auth: "Paulo Coelho ",
      rating: "4/5",
      buy_link: "gdjjdgj",
      price: 300,
      description:
        "Note: If you're using this it may mean you're doing some of your own routing in your app, and we'd like to know what your use case is. We may be able to provide something higher-level to better suit your needs.",
    },
  ],
};
